import React, { FC, useEffect, useMemo, useRef, useState } from 'react'
import { observer } from 'mobx-react'
import { IonSlides, IonSlide, useIonViewDidEnter, useIonViewWillLeave, IonModal } from '@ionic/react'
import { advertMobx, memberMobx } from '@mobxStore'
import { productMobx } from '@mobx/mall'
import { getCouponsInfo, getHistoryNew, showMsg } from '@utils'
import mktController from 'controllers/mktController'
import { defaultAdStyleEnum } from '@common/configMap'
import Notice from '@pages/home/components/Notice'
import MSDK from 'sdk/monitor'
import { restaurantConfig } from 'restaurant'
import { defaultCouponBg } from '@mobx/menu/advert.mobx'
import ActivityApi from '@api/activity.api'
import { cloneDeep, each } from '@dt/fe-utils/dist/lodash'
import CouponItem from 'components/mkt/CouponItem'
import './index.scss'

// props
interface IProps {
  hash?: string;
  /** 类型 */
  type: TAdvertCaseType;
  /** 广告展示位置 目前弹窗使用，首页或者点单页 */
  showPage?: 'home' | 'meals';
  /** 限定宽度 */
  wrapWidth?: number;
  wrapNode?: any;
  /** 关闭弹窗 */
  reject?: () => void;
  /** 点击事件 */
  onClick?: () => void;
}

let debounceTimer
let sliderTime
const Advert: FC<IProps> = ({ type, hash = '', wrapWidth, showPage, reject, onClick }) => {
  const defaultAdStyle = defaultAdStyleEnum[type]
  const { advertInfo, availableAdsMap, showAdvert } = advertMobx
  const { interval, style, width, height, outTime } = { ...defaultAdStyle, ...advertInfo[type] } as IAdvertDesignCase
  const [adList, setAdList] = useState([])
  const [adIndex, setAdIndex] = useState(0)
  const [couponDetails, setCouponDetails] = useState([])
  const [isLoaded, setIsLoaded] = useState(false)
  const isModal = type === 'popUps'
  const history = getHistoryNew()

  const slidesRef = useRef(null)

  /**
   * 数据采集
   */
  const isShowAdvert = useMemo(() => showAdvert && adList?.length && !isModal, [showAdvert, adList?.length, isModal])
  // 点击和曝光上报
  const handleTrace = (eventType, ad, index) => {
    MSDK.trackClicks({ eventType, ad, adType: type, page: index })
  }
  const handleSlideChange = () => {
    const advert = (document.getElementById(`advertElement${type}`) as any)
    if (advert && advert.swiper) {
      const ad = adList[advert.swiper.realIndex]
      setAdIndex(advert.swiper.realIndex)
      handleTrace('ad_show', ad, advert.swiper.realIndex)
    }
  }

  // 轮播参数
  const slideOpts = useMemo(() => {
    return {
      initialSlide: 0,
      speed: 300,
      autoplay: type !== 'popUps' && adList?.length > 1 ? {
        delay: type === 'openScreen' ? (outTime || 5) / adList.length * 1000 : interval,
        disableOnInteraction: type === 'openScreen'
      } : false,
      loop: type !== 'popUps' && adList?.length > 1
    }
  }, [adList, interval])

  // 广告位项样式 map
  const itemStyleMap: any = useMemo(() => {
    const _width = wrapWidth ? width / wrapWidth : width
    const _height = height / _width
    return {
      home: {
        width: wrapWidth ? `${wrapWidth}px` : 'calc(100vw)',
        height: wrapWidth ? `${_height}px` : `calc(${height / width * 100}vw)`,
      },
      menu: {
        width: wrapWidth ? `${wrapWidth}px` : 'calc(93.6vw)',
        height: wrapWidth ? `${_height}px` : `calc((93.6vw) * ${height / width})`,
        borderRadius: '8px',
      },
      finish: {
        width: wrapWidth ? `${wrapWidth}px` : 'calc(100vw - 16px)',
        height: wrapWidth ? `${_height}px` : `calc((93.6vw) * ${height / width})`,
        borderRadius: '8px',
        margin: '8px'
      },
      openScreen: {
        width: '100vw',
        height: '100vh',
      },
      buyTogether: {
        width: '93.6vw',
        height: '240px',
      },
      popUps: {
        width: '305px',
        height: '404px',
      },
    }
  }, [width, height])

  // 广告位项样式
  const itemStyle = useMemo(() => {
    return itemStyleMap[type]
  }, [itemStyleMap, type])

  // 轮播广告位
  const renderSlide = () => {
    clearTimeout(sliderTime)
    if (isModal) {
      sliderTime = setTimeout(() => {
        updateSlides()
      }, 300)
    }
    return (
      <IonSlides
        ref={slidesRef}
        id={`advertElement${type}${hash}`}
        options={slideOpts}
        pager={adList.length > 1}
        onIonSlideTransitionEnd={handleSlideChange}
        onIonSlideTouchStart={handleSlideTouchStart}
        onIonSlidesDidLoad={handleSlideDidLoad}
        data-cypid={`advertElement${type}`}
      >
        {
          adList.map((item, index) => {
            if (item.type === 'receiveCoupon' && !memberMobx.unacquiredCoupons.length) return null
            return (
              <IonSlide
                key={`${item.type}_${item.pic}`}
                style={{
                  width: itemStyle.width,
                }}
              >
                <div key={`${item.type}_${item.pic}`}>
                  <img
                    className='swiper-item object-fit-cover'
                    src={item.pic}
                    key={`${item.type}_${item.pic}`}
                    onClick={() => handleClick(item, index)}
                    data-cypid={`advert_${type}_${index}`}
                    style={{
                      ...itemStyle
                    }}
                  />
                  <CouponWrap ad={item} index={index} />
                </div>
              </IonSlide>
            )
          })
        }
      </IonSlides>
    )
  }

  // 待领取优惠券
  const CouponWrap = ({ ad, index }) => {
    return ad.type !== 'receiveCoupon' ? <></> : (
      <div className='banner-receive-coupon'>
        <div className='mask' onClick={() => handleClick(ad, index)}></div>
        {ad.pic === defaultCouponBg.pic && (
          <div className='coupon-title'>
            <div className='title'>{i18n.t('advert.receiveCouponBannerTitle')}</div>
            <div>Pending coupon</div>
          </div>
        )}
        <div className='coupon-content'>
          {
            couponDetails.map((coupon) => {
              return (
                <div className='coupon-item' key={coupon.couponId}>
                  <CouponItem type='get' couponInfo={coupon} />
                </div>
              )
            })
          }
        </div>
        {ad.pic === defaultCouponBg.pic && couponDetails.length > 0 && (
          <div className='coupon-btn' onClick={() => handleClick(ad, index)}>{i18n.t('advert.receiveCouponAll')}</div>
        )}
      </div>
    )
  }

  // 平铺广告位
  const renderTile = () => {
    return (
      adList.map((item, index) => (
        <img
          id={`advertElement${type}${hash}`}
          className='tile-item object-fit-cover'
          key={`${item.type}_${item.pic}`}
          src={item.pic}
          style={{
            ...itemStyle,
          }}
          data-cypid={`advert_${type}_${index}`}
          onClick={() => handleClick(item, index)}
        />
      ))
    )
  }

  const calcAdList = () => {
    let list = advertMobx.availableAdsMap[type]
    // 当前页面是否展示
    if (showPage) {
      list = advertMobx.availableAdsGetStoreMap[type][showPage]
    }
    setAdList(cloneDeep(list))
  }

  // 广告位点击
  const handleClick = async (ad: TAdvert, index: number) => {
    ad = ad || adList?.[0]
    onClick?.()
    handleTrace('ad_click', ad, index)
    advertMobx.pick(ad, type)
    if (['mallProduct'].includes(ad.type)) {
      history.push('/advert')
    } else if (['product'].includes(ad.type)) {
      const inMenu = ['/menu'].includes(history.location.pathname)
      const inStore = restaurantConfig.storeId
      const hasLbs = restaurantConfig?.lbs?.lat && restaurantConfig?.lbs?.lng
      const tt = 'advert'
      if (inMenu || inStore) {
        history.push('/advert')
      } else if (hasLbs) {
        history.push(`/advertBrand/${type}/${index}`)
      } else {
        history.push('/store', null, { tt })
      }
    } else if (ad.type === 'activity' && ad.activity?.jumpUrl) {
      mktController.adToActive(history, ad.activity.jumpUrl)
    } else if (ad.type === 'memberCard' && ad.memberCard?.cardId) {
      mktController.adToMemberCard(history, ad.memberCard.cardId)
    } else if (ad.type === 'show' && !!ad.outLink) {
      window.location.href = ad.outLink
    } else if (ad.type === 'redeem') {
      mktController.adToRedeem(history)
    } else if (ad.type === 'groupBuy') {
      mktController.adToGroupBuy(history)
    } else if (ad.type === 'giftCard') {
      mktController.adToGiftCard(history)
    } else if (ad.type === 'receiveCoupon') {
      acquiredCouponList()
      // calcAdList()
    } else if (ad.type === 'weChatWork') {
      history.push(`/weChatWork/${type}`)
    }
  }

  /** 领取优惠券 */
  const acquiredCouponList = async () => {
    reject?.()
    try {
      const res = await memberMobx.acquiredCouponList()
      if (!res.error) {
        showMsg(i18n.t('mkt.coupon.receivedSuccess'), 2000)
        setCouponDetails([])
        return
      }
    } catch (error) {
    }
    showMsg(i18n.t('mkt.coupon.receivedFail'))
  }

  // slide touch start
  const handleSlideTouchStart = (e: any) => {
    if (isLoaded === false) {
      e.stopPropagation()
      return false
    }
  }

  // slide did load
  const handleSlideDidLoad = () => {
    setIsLoaded(true)
    updateSlides()
  }

  const updateSlides = () => {
    if (slidesRef.current) {
      slidesRef.current.update()
    }
  }

  const getCouponsList = () => {
    clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => {
      const unacquiredCoupons = memberMobx.unacquiredCoupons
      if (unacquiredCoupons.length) {
        let coupons = []
        each(unacquiredCoupons, (item: any) => {
          each(item.coupons, (cItem: any) => {
            coupons.push(cItem)
          })
        })
        ActivityApi.getCouponsList({ couponIds: getCouponsInfo(coupons) }).then((res: any) => {
          if (res?.length > 0) {
            setCouponDetails(res)
          }
        })
      } else {
        setCouponDetails([])
      }
    }, 500)
  }

  // 页面即将离开
  useIonViewWillLeave(() => {
    try {
      const advert = (document.getElementById(`advertElement${type}`) as any)
      if (style === 'slide' && adList.length && advert) {
        advert.stopAutoplay()
      }
    } catch (error) {
    }
  })

  // 页面进入
  useIonViewDidEnter(() => {
    try {
      const advert = (document.getElementById(`advertElement${type}`) as any)
      if (!isModal && style === 'slide' && adList.length && advert) {
        advert.startAutoplay()
      }
    } catch (error) {
    }
  })

  useEffect(() => {
    let observerNode
    const target = document.getElementById(`advertElement${type}${hash}`)
    if (isShowAdvert) {
      try {
        observerNode = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              // console.log('观察的元素进入了可视范围 ===> ', type)
              // do something when the observed element enters the viewport
              // observer.unobserve(entry.target) // 停止观察已经进入可视范围的元素
              try {
                handleTrace('ad_show', adList[adIndex], adIndex)
              } catch (error) {
              }
            }
          })
        })
        observerNode.observe(target)
      } catch (error) {
      }
    }
    return () => {
      try {
        observerNode?.unobserve(target)
      } catch (error) {
      }
    }
  }, [isShowAdvert])

  useEffect(() => {
    getCouponsList()
  }, [memberMobx.unacquiredCoupons])

  useEffect(() => {
    const hasMallProduct = !!(adList?.find(item => item.type === 'mallProduct'))
    if (hasMallProduct && !productMobx.viewProducts?.length) {
      productMobx.init()
    }
    calcAdList()
  }, [availableAdsMap[type]])

  return (
    <>
      {
        showAdvert && adList.length ? (
          isModal ? (
            <IonModal
              isOpen
              backdropDismiss
              cssClass='advert-wrapper popUps-modal popUps'
            >
              <div className='popUps-modal-content'>
                {renderSlide()}
                <i className='iconfont icon-close' data-cypid='advertModalClose' onClick={reject} />
              </div>
            </IonModal>
          ) : (
            <div className={`advert-wrapper ${type}`} style={{ 'marginTop': type === 'finish' ? '2px' : (type === 'menu' ? '8px' : '0'), 'marginBottom': type === 'openScreen' || type === 'home' ? '0' : '8px' }}>
              {style === 'tile' ? renderTile() : renderSlide()}
              <Notice type={type} />
            </div>
          )
        ) : null
      }
    </>
  )
}

export default observer(Advert)
